export const mockJobPosts = [
  // ─── Penetration Testing ───
  {
    id: 'job1',
    user_id: 'recruiter1',
    type: 'job' as const,
    title: '[CrowdStrike] Senior Penetration Tester (Remote, Global)',
    content: 'CrowdStrike Adversary Services 팀에서 시니어 침투 테스터를 채용합니다. 글로벌 Fortune 500 고객 대상 Red Team 오퍼레이션, APT 시뮬레이션, 클라우드 환경 침투 테스트 수행. OSCP/OSEP 필수, Cobalt Strike·Havoc C2 운용 경험 우대. 연봉 $130K–$180K + RSU. 100% 원격 근무.',
    company: 'CrowdStrike',
    position: 'Senior Penetration Tester',
    salary: '$130K–$180K',
    location: 'Remote (Global)',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 30 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['penetration-testing', 'red-team', 'cloud', 'remote'],
    category: 'pentest',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 412,
    replies_count: 94,
    views_count: 8231,
    created_at: new Date(Date.now() - 2 * 3600000).toISOString(),
    profiles: { id: 'recruiter1', username: 'crowdstrike_careers', display_name: 'CrowdStrike Careers', points: 5120, reputation: 1024 },
    apply_url: 'https://www.crowdstrike.com/careers/',
    responsibilities: [
      'Fortune 500 기업 대상 Red Team 오퍼레이션 수행',
      'APT 그룹 시뮬레이션 및 공격 시나리오 설계',
      'AWS/Azure/GCP 클라우드 환경 침투 테스트',
      'Cobalt Strike, Havoc C2 인프라 구축 및 운용',
      '취약점 발견 및 상세 보고서 작성',
      '고객사 보안팀 대상 기술 브리핑 및 교육'
    ],
    requirements: [
      'OSCP 또는 OSEP 자격증 필수',
      '침투 테스트 실무 경력 5년 이상',
      'Windows/Linux 시스템 해킹 전문 지식',
      'Active Directory 공격 기법 숙련',
      'Python, PowerShell 스크립팅 능력',
      '영어 커뮤니케이션 능력 (업무 필수)'
    ],
    preferred: [
      'GXPN, GREM, OSEE 등 고급 자격증 보유',
      'C2 프레임워크 커스터마이징 경험',
      'Kubernetes 환경 침투 테스트 경험',
      '제로데이 취약점 발굴 경험',
      'CTF 대회 입상 경력',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 $130K–$180K + RSU (스톡옵션)',
      '100% 원격 근무 (글로벌 어디서나)',
      '최신 해킹 장비 및 라이선스 제공',
      '연간 교육비 $5,000 지원',
      '건강보험 100% 회사 부담',
      '무제한 유급휴가 정책'
    ]
  },
  {
    id: 'job2',
    user_id: 'recruiter2',
    type: 'job' as const,
    title: '[카카오] 모의해킹 전문가 경력직 채용 (판교)',
    content: '카카오 정보보호팀에서 모의해킹 전문가를 채용합니다. 웹·모바일·API 취약점 진단, 내부 인프라 Red Team 수행, 취약점 보고서 작성 및 개발팀 협업. OSCP·OSWE 보유자 우대. 연봉 7,000만~1억 2,000만 원, 스톡옵션 제공.',
    company: '카카오',
    position: '모의해킹 전문가',
    salary: '7,000만~1억 2,000만원',
    location: '판교',
    experience: '3년 이상',
    deadline: new Date(Date.now() + 25 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['penetration-testing', 'web', 'api', 'senior'],
    category: 'pentest',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 378,
    replies_count: 87,
    views_count: 7102,
    created_at: new Date(Date.now() - 6 * 3600000).toISOString(),
    profiles: { id: 'recruiter2', username: 'kakao_security', display_name: 'Kakao Security', points: 4320, reputation: 864 },
    apply_url: 'https://careers.kakao.com/jobs',
    responsibilities: [
      '카카오톡, 카카오페이 등 주요 서비스 모의해킹',
      'Web/Mobile/API 취약점 진단 및 분석',
      '내부 인프라 대상 Red Team 오퍼레이션',
      '취약점 보고서 작성 및 개발팀 협업',
      '보안 가이드라인 수립 및 교육',
      '신규 서비스 출시 전 보안 검토'
    ],
    requirements: [
      '모의해킹 실무 경력 3년 이상',
      'OWASP Top 10 취약점 분석 능력',
      'Burp Suite, Metasploit 등 도구 숙련',
      'Python, JavaScript 코드 분석 능력',
      '취약점 보고서 작성 능력',
      '개발팀과 원활한 커뮤니케이션 능력'
    ],
    preferred: [
      'OSCP, OSWE, CEH 자격증 보유',
      'Bug Bounty 프로그램 참여 경험',
      'Android/iOS 앱 취약점 분석 경험',
      'GraphQL, gRPC API 테스트 경험',
      'AWS/GCP 클라우드 환경 진단 경험',
      '보안 컨퍼런스 발표 또는 논문 작성 경험'
    ],
    benefits: [
      '연봉 7,000만~1억 2,000만원 + 스톡옵션',
      '자율 출퇴근제 (코어타임 11:00~16:00)',
      '재택근무 주 2회 가능',
      '최신 MacBook Pro + 듀얼 모니터 제공',
      '교육비 전액 지원 (자격증, 컨퍼런스)',
      '판교 사옥 내 카페테리아, 헬스장 무료'
    ]
  },
  {
    id: 'job3',
    user_id: 'recruiter3',
    type: 'job' as const,
    title: '[Offensive Security] Course Developer & Pentester (OSCP Lab)',
    content: 'OffSec에서 OSCP/OSEP 랩 환경 개발 및 침투 테스트 강사를 채용합니다. 실제 취약한 머신 설계, 익스플로잇 시나리오 작성, 학습자 멘토링. OSCP·OSED·OSEP 보유 필수. 완전 원격, 연봉 $110K–$150K.',
    company: 'Offensive Security',
    position: 'Course Developer & Pentester',
    salary: '$110K–$150K',
    location: 'Remote',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 45 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['penetration-testing', 'exploit-dev', 'education', 'remote'],
    category: 'pentest',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 334,
    replies_count: 76,
    views_count: 6450,
    created_at: new Date(Date.now() - 14 * 3600000).toISOString(),
    profiles: { id: 'recruiter3', username: 'offsec_careers', display_name: 'OffSec Careers', points: 4780, reputation: 956 },
    apply_url: 'https://www.offsec.com/careers/',
    responsibilities: [
      'OSCP/OSEP 랩 환경용 취약한 머신 설계 및 개발',
      '익스플로잇 시나리오 및 학습 경로 작성',
      '코스 콘텐츠 업데이트 및 품질 관리',
      '학습자 대상 기술 멘토링 및 Q&A',
      '최신 해킹 기법 연구 및 교육 자료 반영',
      '글로벌 보안 커뮤니티와 협업'
    ],
    requirements: [
      'OSCP, OSED, OSEP 자격증 필수',
      '침투 테스트 실무 경력 5년 이상',
      'Linux/Windows 시스템 익스플로잇 개발 능력',
      'Python, Bash, PowerShell 스크립팅',
      '영어 작문 및 커뮤니케이션 능력 (필수)',
      '교육 콘텐츠 제작 경험'
    ],
    preferred: [
      'GXPN, GREM 등 추가 자격증 보유',
      'CTF 출제 또는 운영 경험',
      'Exploit-DB 기여 경력',
      '보안 컨퍼런스 강연 경험',
      'Docker/Kubernetes 환경 구축 경험',
      '오픈소스 보안 도구 개발 경험'
    ],
    benefits: [
      '연봉 $110K–$150K',
      '100% 원격 근무 (시간대 자유)',
      '모든 OffSec 코스 무료 수강',
      '연간 컨퍼런스 참가비 전액 지원',
      '최신 해킹 장비 및 소프트웨어 제공',
      '유연한 근무 시간 및 무제한 휴가'
    ]
  },
  {
    id: 'job4',
    user_id: 'recruiter4',
    type: 'job' as const,
    title: '[토스] Red Team Operator – APT 시뮬레이션 전문가',
    content: '토스 보안팀에서 Red Team 오퍼레이터를 모집합니다. 내부 네트워크 침투, Active Directory 공격, C2 인프라 구축 및 운용. Cobalt Strike·Sliver·Brute Ratel 경험 필수. 연봉 8,000만~1억 3,000만 원, 재택 50%.',
    company: '토스',
    position: 'Red Team Operator',
    salary: '8,000만~1억 3,000만원',
    location: '서울 (재택 50%)',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 20 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['red-team', 'apt', 'active-directory', 'c2'],
    category: 'redteam',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 301,
    replies_count: 68,
    views_count: 5890,
    created_at: new Date(Date.now() - 20 * 3600000).toISOString(),
    profiles: { id: 'recruiter4', username: 'toss_security', display_name: 'Toss Security', points: 4560, reputation: 912 },
    apply_url: 'https://toss.im/career/jobs',
    responsibilities: [
      '토스뱅크, 토스증권 내부 네트워크 Red Team 오퍼레이션',
      'APT 그룹 TTP 기반 공격 시뮬레이션',
      'Active Directory 환경 침투 및 권한 상승',
      'C2 인프라 구축 및 은닉 기법 연구',
      'Blue Team과 협업하여 탐지 룰 고도화',
      '경영진 대상 보안 위험 보고'
    ],
    requirements: [
      'Red Team 실무 경력 5년 이상',
      'Cobalt Strike, Sliver, Brute Ratel 운용 능력',
      'Active Directory 공격 기법 전문 지식',
      'Windows/Linux 시스템 해킹 능력',
      'Python, PowerShell, C# 개발 능력',
      'MITRE ATT&CK 프레임워크 이해'
    ],
    preferred: [
      'OSEP, CRTO, PNPT 자격증 보유',
      'C2 프레임워크 커스터마이징 경험',
      'EDR 우회 기법 연구 경험',
      'Kerberos 공격 (Golden/Silver Ticket) 경험',
      '금융권 보안 컴플라이언스 이해',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 8,000만~1억 3,000만원 + 스톡옵션',
      '재택근무 주 2~3회 (50%)',
      '자율 출퇴근제',
      '최신 MacBook Pro + 해킹 장비 제공',
      '교육비 무제한 지원',
      '강남 오피스 + 프리미엄 간식/식사'
    ]
  },
  {
    id: 'job5',
    user_id: 'recruiter5',
    type: 'job' as const,
    title: '[NCC Group] Principal Security Consultant – Hardware Hacking',
    content: 'NCC Group에서 하드웨어 보안 컨설턴트를 채용합니다. IoT·임베디드 기기 펌웨어 분석, JTAG/UART 디버깅, 하드웨어 취약점 연구. IDA Pro·Ghidra 숙련자 우대. 런던/서울 오피스 또는 원격. 연봉 £80K–£110K.',
    company: 'NCC Group',
    position: 'Principal Security Consultant',
    salary: '£80K–£110K',
    location: '런던/서울/원격',
    experience: '7년 이상',
    deadline: new Date(Date.now() + 35 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['hardware-hacking', 'iot', 'firmware', 'embedded'],
    category: 'research',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 267,
    replies_count: 59,
    views_count: 4780,
    created_at: new Date(Date.now() - 28 * 3600000).toISOString(),
    profiles: { id: 'recruiter5', username: 'nccgroup_careers', display_name: 'NCC Group', points: 4230, reputation: 846 },
    apply_url: 'https://www.nccgroup.com/careers/',
    responsibilities: [
      'IoT 및 임베디드 기기 보안 평가',
      '펌웨어 추출 및 리버스 엔지니어링',
      'JTAG, UART, SPI 등 하드웨어 인터페이스 디버깅',
      '하드웨어 취약점 발굴 및 익스플로잇 개발',
      '고객사 대상 보안 컨설팅 및 보고서 작성',
      '하드웨어 보안 연구 및 논문 발표'
    ],
    requirements: [
      '하드웨어 보안 실무 경력 7년 이상',
      'IDA Pro, Ghidra 리버싱 도구 숙련',
      'ARM, MIPS 아키텍처 이해',
      '펌웨어 분석 및 취약점 발굴 경험',
      'C, Python 프로그래밍 능력',
      '영어 커뮤니케이션 능력 (필수)'
    ],
    preferred: [
      'JTAG, SWD 디버거 사용 경험',
      'Side-channel 공격 (전력 분석 등) 경험',
      'RTOS (FreeRTOS, Zephyr) 분석 경험',
      'CVE 발표 실적',
      '보안 컨퍼런스 (Black Hat, DEF CON) 발표',
      '오픈소스 하드웨어 프로젝트 기여'
    ],
    benefits: [
      '연봉 £80K–£110K (약 1억 3천~1억 8천만원)',
      '런던/서울 오피스 또는 원격 근무 선택',
      '최신 하드웨어 분석 장비 제공',
      '연간 교육비 £5,000 지원',
      '글로벌 보안 컨퍼런스 참가 지원',
      '유연한 근무 시간'
    ]
  },

  // ─── Application Security ───
  {
    id: 'job6',
    user_id: 'recruiter6',
    type: 'job' as const,
    title: '[네이버] Application Security Engineer – AI 서비스 보안',
    content: '네이버 클로바·하이퍼클로바X AI 서비스 보안을 담당할 AppSec 엔지니어를 채용합니다. LLM 프롬프트 인젝션 대응, AI 파이프라인 보안 설계, SAST/DAST 자동화. Python·Go 개발 경험 필수. 연봉 7,500만~1억 원.',
    company: '네이버',
    position: 'Application Security Engineer',
    salary: '7,500만~1억원',
    location: '분당',
    experience: '4년 이상',
    deadline: new Date(Date.now() + 28 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['appsec', 'ai-security', 'llm', 'sast'],
    category: 'appsec',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 445,
    replies_count: 103,
    views_count: 8920,
    created_at: new Date(Date.now() - 4 * 3600000).toISOString(),
    profiles: { id: 'recruiter6', username: 'naver_security', display_name: 'Naver Security', points: 5340, reputation: 1068 },
    apply_url: 'https://recruit.navercorp.com/',
    responsibilities: [
      '하이퍼클로바X, 클로바 AI 서비스 보안 설계',
      'LLM 프롬프트 인젝션 및 탈옥 공격 대응',
      'AI 파이프라인 (학습/추론) 보안 검토',
      'SAST/DAST 도구 자동화 및 CI/CD 통합',
      '개발팀 대상 시큐어 코딩 교육',
      'AI 보안 가이드라인 수립'
    ],
    requirements: [
      'Application Security 실무 경력 4년 이상',
      'Python, Go 개발 능력',
      'OWASP Top 10, SANS Top 25 이해',
      'SAST/DAST 도구 (SonarQube, Burp) 경험',
      'AI/ML 기본 지식 (LLM 이해)',
      '개발팀과 협업 경험'
    ],
    preferred: [
      'LLM 보안 (프롬프트 인젝션, 데이터 유출) 연구 경험',
      'AI Red Team 또는 Adversarial ML 경험',
      'Kubernetes, Docker 환경 보안 경험',
      'Bug Bounty 프로그램 운영 경험',
      'CISSP, CEH 자격증 보유',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 7,500만~1억원 + 스톡옵션',
      '자율 출퇴근제 (코어타임 없음)',
      '재택근무 주 2회',
      '최신 MacBook Pro + 개발 장비',
      '교육비 전액 지원',
      '분당 그린팩토리 근무 (사내 카페, 헬스장)'
    ]
  },
  {
    id: 'job7',
    user_id: 'recruiter7',
    type: 'job' as const,
    title: '[GitHub] Staff Security Engineer – Supply Chain Security',
    content: 'GitHub에서 소프트웨어 공급망 보안 전문가를 채용합니다. Dependabot·Secret Scanning·Code Scanning 기능 개발, OSS 취약점 데이터베이스 관리, SBOM 표준화. Ruby·Go 경험 필수. 연봉 $160K–$220K + RSU.',
    company: 'GitHub',
    position: 'Staff Security Engineer',
    salary: '$160K–$220K',
    location: 'Remote/San Francisco',
    experience: '7년 이상',
    deadline: new Date(Date.now() + 40 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['appsec', 'supply-chain', 'sbom', 'oss-security'],
    category: 'appsec',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 523,
    replies_count: 118,
    views_count: 10234,
    created_at: new Date(Date.now() - 10 * 3600000).toISOString(),
    profiles: { id: 'recruiter7', username: 'github_security', display_name: 'GitHub Security', points: 6120, reputation: 1224 },
    apply_url: 'https://github.com/careers',
    responsibilities: [
      'Dependabot, Secret Scanning 기능 개발 및 개선',
      'OSS 취약점 데이터베이스 (Advisory DB) 관리',
      'SBOM (Software Bill of Materials) 표준화',
      '공급망 공격 탐지 알고리즘 개발',
      'GitHub Advanced Security 기능 확장',
      '글로벌 보안 커뮤니티와 협업'
    ],
    requirements: [
      'Software Security 실무 경력 7년 이상',
      'Ruby, Go 개발 능력 (필수)',
      'OSS 생태계 및 패키지 관리자 이해',
      'SBOM, SLSA 프레임워크 지식',
      'Git, CI/CD 파이프라인 보안 경험',
      '영어 커뮤니케이션 능력 (필수)'
    ],
    preferred: [
      'CVE 발표 또는 OSS 취약점 발굴 경험',
      'npm, PyPI, RubyGems 등 패키지 생태계 경험',
      'Supply Chain Levels for Software Artifacts (SLSA) 경험',
      'Sigstore, in-toto 등 서명 프레임워크 경험',
      '오픈소스 프로젝트 메인테이너 경험',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 $160K–$220K + RSU',
      '100% 원격 근무 또는 샌프란시스코 오피스',
      'GitHub Enterprise 무제한 사용',
      '연간 교육비 $10,000 지원',
      '최신 개발 장비 제공',
      '무제한 유급휴가 정책'
    ]
  },
  {
    id: 'job8',
    user_id: 'recruiter8',
    type: 'job' as const,
    title: '[당근] DevSecOps Engineer – CI/CD 보안 자동화',
    content: '당근에서 DevSecOps 엔지니어를 모집합니다. GitHub Actions 보안 파이프라인 구축, 컨테이너 이미지 취약점 스캔(Trivy·Grype), IaC 보안 검토(Checkov). Kubernetes·Terraform 경험 필수. 연봉 7,000만~1억 원, 완전 자율 출퇴근.',
    company: '당근',
    position: 'DevSecOps Engineer',
    salary: '7,000만~1억원',
    location: '서울 (자율출퇴근)',
    experience: '3년 이상',
    deadline: new Date(Date.now() + 22 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['devsecops', 'kubernetes', 'ci-cd', 'automation'],
    category: 'appsec',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 389,
    replies_count: 91,
    views_count: 7340,
    created_at: new Date(Date.now() - 18 * 3600000).toISOString(),
    profiles: { id: 'recruiter8', username: 'daangn_security', display_name: 'Daangn Security', points: 4890, reputation: 978 },
    apply_url: 'https://team.daangn.com/jobs/',
    responsibilities: [
      'GitHub Actions 기반 보안 파이프라인 구축',
      'Trivy, Grype로 컨테이너 이미지 취약점 스캔',
      'Checkov, tfsec로 IaC (Terraform) 보안 검토',
      'Kubernetes 클러스터 보안 강화 (PSP, OPA)',
      'Secret 관리 자동화 (Vault, SOPS)',
      '개발팀 대상 DevSecOps 교육'
    ],
    requirements: [
      'DevSecOps 실무 경력 3년 이상',
      'Kubernetes, Docker 운영 경험',
      'Terraform, Ansible 등 IaC 도구 경험',
      'CI/CD 파이프라인 (GitHub Actions, Jenkins) 구축',
      'Python, Bash 스크립팅 능력',
      'AWS, GCP 클라우드 경험'
    ],
    preferred: [
      'CKS (Certified Kubernetes Security Specialist) 자격증',
      'Falco, Cilium 등 런타임 보안 도구 경험',
      'Service Mesh (Istio, Linkerd) 보안 경험',
      'SAST/DAST 도구 통합 경험',
      'Bug Bounty 프로그램 참여 경험',
      '오픈소스 보안 도구 개발 경험'
    ],
    benefits: [
      '연봉 7,000만~1억원 + 스톡옵션',
      '완전 자율 출퇴근 (코어타임 없음)',
      '재택근무 자유',
      '최신 MacBook Pro + 개발 장비',
      '교육비 무제한 지원',
      '판교/서울 오피스 선택 가능'
    ]
  },
  {
    id: 'job9',
    user_id: 'recruiter9',
    type: 'job' as const,
    title: '[크래프톤] 게임 보안 엔지니어 – 안티치트 시스템 개발',
    content: 'KRAFTON PUBG 스튜디오에서 안티치트 엔지니어를 채용합니다. 커널 레벨 안티치트 개발, 메모리 조작 탐지, 치트 리버싱 및 대응. Windows 커널 드라이버 개발 경험 필수. 연봉 8,000만~1억 2,000만 원.',
    company: '크래프톤',
    position: '게임 보안 엔지니어',
    salary: '8,000만~1억 2,000만원',
    location: '분당',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 18 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['game-security', 'anti-cheat', 'kernel', 'reversing'],
    category: 'research',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 467,
    replies_count: 109,
    views_count: 9120,
    created_at: new Date(Date.now() - 26 * 3600000).toISOString(),
    profiles: { id: 'recruiter9', username: 'krafton_security', display_name: 'KRAFTON Security', points: 5560, reputation: 1112 },
    apply_url: 'https://www.krafton.com/careers/',
    responsibilities: [
      'PUBG 안티치트 시스템 개발 및 고도화',
      'Windows 커널 드라이버 개발',
      '메모리 조작, 속도핵 등 치트 탐지 알고리즘 개발',
      '치트 프로그램 리버싱 및 대응 방안 수립',
      '게임 클라이언트 보안 강화 (코드 난독화, 무결성 검증)',
      '글로벌 치트 트렌드 분석 및 대응'
    ],
    requirements: [
      '게임 보안 또는 시스템 보안 경력 5년 이상',
      'Windows 커널 드라이버 개발 경험 (필수)',
      'C/C++ 고급 프로그래밍 능력',
      'IDA Pro, x64dbg 리버싱 도구 숙련',
      'Windows Internals 깊은 이해',
      '치트 프로그램 분석 경험'
    ],
    preferred: [
      'EAC, BattlEye 등 안티치트 솔루션 경험',
      'Hypervisor 기반 보안 기술 경험',
      'DRM, 코드 난독화 기술 경험',
      'Unreal Engine, Unity 게임 엔진 이해',
      'CVE 발표 또는 보안 연구 경험',
      '게임 해킹 커뮤니티 분석 경험'
    ],
    benefits: [
      '연봉 8,000만~1억 2,000만원 + 성과급',
      '자율 출퇴근제',
      '재택근무 주 1~2회',
      '최신 개발 장비 + 게이밍 PC 제공',
      '교육비 전액 지원',
      '분당 사옥 내 게임룸, 카페테리아'
    ]
  },

  // ─── Cloud Security ───
  {
    id: 'job10',
    user_id: 'recruiter10',
    type: 'job' as const,
    title: '[AWS] Senior Security Engineer – AWS GuardDuty (Seoul)',
    content: 'Amazon Web Services 서울 오피스에서 GuardDuty 위협 탐지 엔진 개발 엔지니어를 채용합니다. ML 기반 이상 탐지 모델 개발, 클라우드 공격 시나리오 연구, 글로벌 위협 인텔리전스 통합. Java·Python 필수. 연봉 $150K–$200K + RSU.',
    company: 'AWS',
    position: 'Senior Security Engineer',
    salary: '$150K–$200K',
    location: '서울',
    experience: '6년 이상',
    deadline: new Date(Date.now() + 32 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['cloud-security', 'aws', 'threat-detection', 'ml-security'],
    category: 'cloud',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 589,
    replies_count: 134,
    views_count: 11450,
    created_at: new Date(Date.now() - 3 * 3600000).toISOString(),
    profiles: { id: 'recruiter10', username: 'aws_security', display_name: 'AWS Security', points: 6780, reputation: 1356 },
    apply_url: 'https://www.amazon.jobs/en/teams/aws-security',
    responsibilities: [
      'AWS GuardDuty 위협 탐지 엔진 개발',
      'ML 기반 이상 탐지 모델 설계 및 학습',
      '클라우드 공격 시나리오 (IAM 탈취, 크립토마이닝 등) 연구',
      '글로벌 위협 인텔리전스 피드 통합',
      'AWS 서비스 보안 강화 협업',
      '고객 대상 보안 가이드 작성'
    ],
    requirements: [
      'Cloud Security 실무 경력 6년 이상',
      'Java, Python 개발 능력 (필수)',
      'AWS 서비스 (EC2, S3, IAM, Lambda) 깊은 이해',
      'ML/AI 기반 이상 탐지 경험',
      'MITRE ATT&CK for Cloud 이해',
      '영어 커뮤니케이션 능력 (필수)'
    ],
    preferred: [
      'AWS Security Specialty 자격증',
      'Threat Intelligence 플랫폼 개발 경험',
      'SIEM (Splunk, ELK) 운영 경험',
      'CloudTrail, VPC Flow Logs 분석 경험',
      'Bug Bounty 프로그램 참여 경험',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 $150K–$200K + RSU',
      '서울 오피스 근무',
      '재택근무 주 2회',
      '최신 개발 장비 제공',
      'AWS 자격증 취득 전액 지원',
      '글로벌 보안 컨퍼런스 참가 지원'
    ]
  },
  {
    id: 'job11',
    user_id: 'recruiter11',
    type: 'job' as const,
    title: '[삼성SDS] 클라우드 보안 아키텍트 – 멀티클라우드 거버넌스',
    content: '삼성SDS에서 멀티클라우드(AWS·Azure·GCP) 보안 아키텍트를 채용합니다. CSPM 구축, IAM 정책 설계, 클라우드 컴플라이언스(ISO27001·SOC2) 대응. AWS Security Specialty 필수. 연봉 8,000만~1억 2,000만 원.',
    company: '삼성SDS',
    position: '클라우드 보안 아키텍트',
    salary: '8,000만~1억 2,000만원',
    location: '서울/수원',
    experience: '7년 이상',
    deadline: new Date(Date.now() + 15 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['cloud-security', 'aws', 'azure', 'cspm'],
    category: 'cloud',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 312,
    replies_count: 72,
    views_count: 5670,
    created_at: new Date(Date.now() - 32 * 3600000).toISOString(),
    profiles: { id: 'recruiter11', username: 'samsungsds_security', display_name: 'Samsung SDS', points: 4450, reputation: 890 },
    apply_url: 'https://www.samsungsds.com/careers/',
    responsibilities: [
      '멀티클라우드 (AWS, Azure, GCP) 보안 아키텍처 설계',
      'CSPM (Cloud Security Posture Management) 구축',
      'IAM 정책 설계 및 Zero Trust 아키텍처 구현',
      '클라우드 컴플라이언스 (ISO27001, SOC2, PCI-DSS) 대응',
      '클라우드 보안 가이드라인 수립',
      '고객사 클라우드 보안 컨설팅'
    ],
    requirements: [
      'Cloud Security 실무 경력 7년 이상',
      'AWS Security Specialty 자격증 (필수)',
      'AWS, Azure, GCP 멀티클라우드 경험',
      'Terraform, CloudFormation 등 IaC 경험',
      'ISO27001, SOC2 등 컴플라이언스 이해',
      '보안 아키텍처 설계 경험'
    ],
    preferred: [
      'Azure Security Engineer, GCP Security 자격증',
      'CSPM 도구 (Prisma Cloud, Wiz) 운영 경험',
      'Zero Trust 아키텍처 구현 경험',
      'SIEM, SOAR 통합 경험',
      'CISSP, CISM 자격증',
      '대기업 또는 금융권 프로젝트 경험'
    ],
    benefits: [
      '연봉 8,000만~1억 2,000만원',
      '자율 출퇴근제',
      '재택근무 주 1회',
      '최신 개발 장비 제공',
      '클라우드 자격증 취득 전액 지원',
      '서울/수원 오피스 선택 가능'
    ]
  },
  {
    id: 'job12',
    user_id: 'recruiter12',
    type: 'job' as const,
    title: '[Wiz] Cloud Security Researcher (APAC)',
    content: 'Wiz에서 클라우드 보안 연구원을 채용합니다. AWS·Azure·GCP 신규 취약점 연구, 클라우드 공격 기법 개발, 고객 환경 위험 평가 자동화. 클라우드 침투 테스트 경험 필수. 연봉 $140K–$190K + 스톡옵션. 원격 가능.',
    company: 'Wiz',
    position: 'Cloud Security Researcher',
    salary: '$140K–$190K',
    location: 'Remote (APAC)',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 38 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['cloud-security', 'research', 'vulnerability', 'apac'],
    category: 'cloud',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 478,
    replies_count: 112,
    views_count: 9340,
    created_at: new Date(Date.now() - 16 * 3600000).toISOString(),
    profiles: { id: 'recruiter12', username: 'wiz_careers', display_name: 'Wiz Security', points: 5890, reputation: 1178 },
    apply_url: 'https://www.wiz.io/careers',
    responsibilities: [
      'AWS, Azure, GCP 신규 취약점 연구 및 발굴',
      '클라우드 공격 기법 (SSRF, IAM 탈취 등) 개발',
      'Wiz 플랫폼 탐지 룰 개발 및 고도화',
      '고객 환경 위험 평가 자동화',
      'CVE 발표 및 클라우드 벤더 협업',
      '보안 컨퍼런스 발표 및 블로그 작성'
    ],
    requirements: [
      'Cloud Security 실무 경력 5년 이상',
      'AWS, Azure, GCP 침투 테스트 경험',
      'Python, Go 개발 능력',
      'Kubernetes, Docker 보안 이해',
      'CVE 발표 또는 취약점 연구 경험',
      '영어 커뮤니케이션 능력 (필수)'
    ],
    preferred: [
      'AWS/Azure/GCP 보안 자격증',
      'CSPM 도구 개발 경험',
      'Serverless (Lambda, Cloud Functions) 보안 연구',
      'Bug Bounty 프로그램 참여 경험',
      'Black Hat, DEF CON 발표 경험',
      '오픈소스 보안 도구 개발 경험'
    ],
    benefits: [
      '연봉 $140K–$190K + 스톡옵션',
      '100% 원격 근무 (APAC 시간대)',
      '최신 개발 장비 제공',
      '연간 교육비 $5,000 지원',
      '글로벌 보안 컨퍼런스 참가 지원',
      '유연한 근무 시간'
    ]
  },

  // ─── SOC / Incident Response ───
  {
    id: 'job13',
    user_id: 'recruiter13',
    type: 'job' as const,
    title: '[Mandiant (Google)] Senior Incident Responder – APAC',
    content: 'Mandiant에서 시니어 침해사고 대응 전문가를 채용합니다. 랜섬웨어·APT 침해 조사, 디지털 포렌식, 위협 인텔리전스 보고서 작성. EnCase·Velociraptor·YARA 경험 필수. 연봉 $130K–$175K. 서울/싱가포르 오피스.',
    company: 'Mandiant (Google)',
    position: 'Senior Incident Responder',
    salary: '$130K–$175K',
    location: '서울/싱가포르',
    experience: '6년 이상',
    deadline: new Date(Date.now() + 27 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['incident-response', 'forensics', 'apt', 'ransomware'],
    category: 'soc',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 534,
    replies_count: 121,
    views_count: 10780,
    created_at: new Date(Date.now() - 5 * 3600000).toISOString(),
    profiles: { id: 'recruiter13', username: 'mandiant_careers', display_name: 'Mandiant (Google)', points: 6340, reputation: 1268 },
    apply_url: 'https://www.mandiant.com/careers',
    responsibilities: [
      '랜섬웨어, APT 침해사고 현장 대응',
      '디지털 포렌식 (메모리, 디스크, 네트워크)',
      '악성코드 분석 및 IOC 추출',
      '위협 인텔리전스 보고서 작성',
      '고객사 경영진 대상 브리핑',
      'APT 그룹 TTP 추적 및 분석'
    ],
    requirements: [
      'Incident Response 실무 경력 6년 이상',
      'EnCase, FTK, Velociraptor 포렌식 도구 숙련',
      'YARA 룰 작성 및 악성코드 분석',
      'Windows/Linux 시스템 포렌식',
      'MITRE ATT&CK 프레임워크 이해',
      '영어 커뮤니케이션 능력 (필수)'
    ],
    preferred: [
      'GCFA, GCFE, GREM 자격증',
      'APT 그룹 (Lazarus, APT29 등) 분석 경험',
      'Memory Forensics (Volatility) 전문 지식',
      'Threat Intelligence 플랫폼 운영 경험',
      '랜섬웨어 복호화 경험',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 $130K–$175K + 보너스',
      '서울 또는 싱가포르 오피스',
      '재택근무 주 2회',
      '최신 포렌식 장비 제공',
      'SANS 교육 전액 지원',
      '글로벌 침해사고 대응 경험'
    ]
  },
  {
    id: 'job14',
    user_id: 'recruiter14',
    type: 'job' as const,
    title: '[안랩] SOC 보안 분석가 – 위협 인텔리전스 팀 (신입 가능)',
    content: '안랩 TIP(Threat Intelligence Platform) 팀에서 보안 분석가를 채용합니다. 악성코드 행위 분석, IOC 추출, 위협 인텔리전스 피드 운영. MITRE ATT&CK 프레임워크 활용 경험 우대. 신입~경력 3년. 연봉 4,500만~7,000만 원.',
    company: '안랩',
    position: 'SOC 보안 분석가',
    salary: '4,500만~7,000만원',
    location: '판교',
    experience: '신입~3년',
    deadline: new Date(Date.now() + 42 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['soc', 'threat-intelligence', 'malware-analysis', 'mitre-attack'],
    category: 'soc',
    region: 'domestic',
    level: 'junior',
    status: 'open',
    likes_count: 398,
    replies_count: 96,
    views_count: 7890,
    created_at: new Date(Date.now() - 12 * 3600000).toISOString(),
    profiles: { id: 'recruiter14', username: 'ahnlab_security', display_name: 'AhnLab Security', points: 5120, reputation: 1024 },
    apply_url: 'https://www.ahnlab.com/kr/site/careers/careers.do',
    responsibilities: [
      '악성코드 샘플 수집 및 행위 분석',
      'IOC (IP, 도메인, 파일 해시) 추출',
      '위협 인텔리전스 피드 운영 및 배포',
      'MITRE ATT&CK 기반 TTP 매핑',
      'V3 백신 탐지 룰 작성 지원',
      '보안 이슈 모니터링 및 보고서 작성'
    ],
    requirements: [
      '정보보안 관련 학과 졸업 또는 동등 경력',
      '악성코드 분석 기초 지식',
      'Python 스크립팅 능력',
      'MITRE ATT&CK 프레임워크 이해',
      '보안 이슈에 대한 관심과 학습 의지',
      '팀워크 및 커뮤니케이션 능력'
    ],
    preferred: [
      '정보보안기사, CISSP 자격증',
      'YARA 룰 작성 경험',
      'Sandbox (Cuckoo, Any.run) 사용 경험',
      'CTF 대회 참여 경험',
      'IDA Pro, Ghidra 리버싱 도구 경험',
      '보안 동아리 또는 연구실 활동'
    ],
    benefits: [
      '연봉 4,500만~7,000만원 (경력에 따라)',
      '자율 출퇴근제',
      '재택근무 주 1회',
      '최신 분석 장비 제공',
      '교육비 전액 지원 (자격증, 컨퍼런스)',
      '판교 사옥 내 카페테리아, 헬스장'
    ]
  },
  {
    id: 'job15',
    user_id: 'recruiter15',
    type: 'job' as const,
    title: '[SK쉴더스] Threat Hunter – 능동적 위협 탐색 전문가',
    content: 'SK쉴더스 Threat Hunting 팀에서 전문가를 채용합니다. EDR 데이터 기반 위협 탐색, 가설 기반 헌팅 플레이북 개발, SIEM 탐지 룰 고도화. CrowdStrike Falcon·SentinelOne 경험 우대. 경력 5년 이상. 연봉 7,000만~1억 원.',
    company: 'SK쉴더스',
    position: 'Threat Hunter',
    salary: '7,000만~1억원',
    location: '서울',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 24 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['threat-hunting', 'edr', 'siem', 'senior'],
    category: 'soc',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 356,
    replies_count: 83,
    views_count: 6780,
    created_at: new Date(Date.now() - 22 * 3600000).toISOString(),
    profiles: { id: 'recruiter15', username: 'skshieldus_security', display_name: 'SK Shieldus', points: 4890, reputation: 978 },
    apply_url: 'https://www.skshieldus.com/kor/recruit/recruit.do',
    responsibilities: [
      'EDR (CrowdStrike, SentinelOne) 데이터 기반 위협 탐색',
      '가설 기반 Threat Hunting 플레이북 개발',
      'SIEM (Splunk, QRadar) 탐지 룰 고도화',
      'APT 공격 지표 분석 및 대응',
      'Threat Intelligence 피드 통합',
      'SOC 팀 대상 Threat Hunting 교육'
    ],
    requirements: [
      'SOC 또는 Threat Hunting 경력 5년 이상',
      'EDR 도구 (CrowdStrike, SentinelOne) 운영 경험',
      'SIEM (Splunk, ELK, QRadar) 쿼리 작성',
      'MITRE ATT&CK 기반 위협 분석',
      'Python, PowerShell 스크립팅',
      'Windows/Linux 시스템 로그 분석'
    ],
    preferred: [
      'GCTI, GCFA 자격증',
      'Threat Intelligence 플랫폼 (MISP, ThreatConnect) 경험',
      'Sigma 룰 작성 경험',
      'Memory Forensics (Volatility) 경험',
      'APT 그룹 TTP 분석 경험',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 7,000만~1억원',
      '자율 출퇴근제',
      '재택근무 주 1회',
      '최신 분석 장비 제공',
      'SANS 교육 전액 지원',
      '서울 오피스 근무'
    ]
  },
  {
    id: 'job16',
    user_id: 'recruiter16',
    type: 'job' as const,
    title: '[KISA] 사이버 위협 분석가 – 국가 사이버위기 대응 (신입)',
    content: 'KISA 사이버침해대응본부에서 위협 분석가를 채용합니다. 국가 주요 기반시설 사이버 위협 모니터링, 악성코드 분석, 취약점 정보 공유(KCERT). 정보보안기사 필수. 공무원 준하는 복지, 워라밸 보장. 연봉 4,800만~7,500만 원.',
    company: 'KISA',
    position: '사이버 위협 분석가',
    salary: '4,800만~7,500만원',
    location: '나주/서울',
    experience: '신입~2년',
    deadline: new Date(Date.now() + 50 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['soc', 'national-security', 'malware', 'public-sector'],
    category: 'soc',
    region: 'domestic',
    level: 'junior',
    status: 'open',
    likes_count: 467,
    replies_count: 108,
    views_count: 9230,
    created_at: new Date(Date.now() - 36 * 3600000).toISOString(),
    profiles: { id: 'recruiter16', username: 'kisa_security', display_name: 'KISA', points: 5670, reputation: 1134 },
    apply_url: 'https://www.kisa.or.kr/main.jsp',
    responsibilities: [
      '국가 주요 기반시설 사이버 위협 모니터링',
      '악성코드 샘플 수집 및 분석',
      'KCERT 취약점 정보 공유 및 대응',
      '사이버 침해사고 신고 접수 및 처리',
      '보안 공지 및 가이드라인 작성',
      '국가 사이버위기 대응 훈련 참여'
    ],
    requirements: [
      '정보보안기사 자격증 (필수)',
      '정보보안 관련 학과 졸업 또는 동등 경력',
      '악성코드 분석 기초 지식',
      'Python 스크립팅 능력',
      '보안 이슈에 대한 관심',
      '공공기관 근무 의지'
    ],
    preferred: [
      'CISSP, CEH 자격증',
      'SOC 또는 CERT 근무 경험',
      'YARA, Snort 룰 작성 경험',
      'CTF 대회 참여 경험',
      '보안 동아리 또는 연구실 활동',
      '영어 기술 문서 독해 능력'
    ],
    benefits: [
      '연봉 4,800만~7,500만원 (호봉제)',
      '공무원 준하는 복지 (연금, 건강보험)',
      '워라밸 보장 (정시 퇴근 문화)',
      '나주 또는 서울 오피스 선택',
      '교육비 전액 지원',
      '국가 사이버보안 전문가 경력 인정'
    ]
  },

  // ─── Security Research ───
  {
    id: 'job17',
    user_id: 'recruiter17',
    type: 'job' as const,
    title: '[Google Project Zero] Security Researcher – Browser Exploitation',
    content: 'Google Project Zero에서 브라우저 보안 연구원을 채용합니다. Chrome·V8 엔진 취약점 연구, 샌드박스 탈출 기법 분석, 제로데이 발굴 및 패치 협업. CVE 발표 실적 필수. 연봉 $180K–$250K + RSU. 서울/마운틴뷰.',
    company: 'Google Project Zero',
    position: 'Security Researcher',
    salary: '$180K–$250K',
    location: '서울/마운틴뷰',
    experience: '8년 이상',
    deadline: new Date(Date.now() + 55 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['research', 'browser-security', 'zero-day', 'exploit-dev'],
    category: 'research',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 712,
    replies_count: 167,
    views_count: 14560,
    created_at: new Date(Date.now() - 8 * 3600000).toISOString(),
    profiles: { id: 'recruiter17', username: 'google_p0', display_name: 'Google Project Zero', points: 8120, reputation: 1624 },
    apply_url: 'https://googleprojectzero.blogspot.com/',
    responsibilities: [
      'Chrome, V8 엔진 취약점 연구 및 발굴',
      '브라우저 샌드박스 탈출 기법 분석',
      '제로데이 취약점 발굴 및 CVE 발표',
      'Chromium 개발팀과 패치 협업',
      '보안 연구 블로그 및 논문 작성',
      '글로벌 보안 컨퍼런스 발표'
    ],
    requirements: [
      'Security Research 경력 8년 이상',
      'CVE 발표 실적 (필수)',
      'C/C++ 고급 프로그래밍 능력',
      'IDA Pro, Ghidra 리버싱 도구 숙련',
      'Browser Exploitation 전문 지식',
      '영어 작문 및 발표 능력 (필수)'
    ],
    preferred: [
      'Pwn2Own, Tianfu Cup 입상 경력',
      'V8, SpiderMonkey 등 JS 엔진 분석 경험',
      'Sandbox 탈출 (Chrome, Edge) 경험',
      'Fuzzing (AFL, LibFuzzer) 경험',
      'Black Hat, DEF CON 발표 경험',
      '오픈소스 보안 도구 개발 경험'
    ],
    benefits: [
      '연봉 $180K–$250K + RSU',
      '서울 또는 마운틴뷰 오피스',
      '재택근무 주 2~3회',
      '최신 연구 장비 제공',
      '글로벌 보안 컨퍼런스 참가 전액 지원',
      '세계 최고 수준의 보안 연구 환경'
    ]
  },
  {
    id: 'job18',
    user_id: 'recruiter18',
    type: 'job' as const,
    title: '[Microsoft MSRC] Vulnerability Researcher – Windows Kernel',
    content: 'Microsoft Security Response Center에서 Windows 커널 취약점 연구원을 채용합니다. 커널 익스플로잇 분석, 패치 우회 기법 연구, 보안 완화 기술 개발. WinDbg·IDA Pro 숙련 필수. 연봉 $170K–$230K + RSU. 레드몬드/서울.',
    company: 'Microsoft MSRC',
    position: 'Vulnerability Researcher',
    salary: '$170K–$230K',
    location: '레드몬드/서울',
    experience: '7년 이상',
    deadline: new Date(Date.now() + 48 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['research', 'windows-kernel', 'vulnerability', 'exploit-dev'],
    category: 'research',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 634,
    replies_count: 145,
    views_count: 12340,
    created_at: new Date(Date.now() - 24 * 3600000).toISOString(),
    profiles: { id: 'recruiter18', username: 'msrc_careers', display_name: 'Microsoft MSRC', points: 7450, reputation: 1490 },
    apply_url: 'https://www.microsoft.com/en-us/msrc',
    responsibilities: [
      'Windows 커널 취약점 연구 및 분석',
      '커널 익스플로잇 개발 및 패치 우회 기법 연구',
      '보안 완화 기술 (CFG, ACG, CET) 개발',
      'Windows 개발팀과 패치 협업',
      'MSRC 보안 공지 작성',
      '보안 컨퍼런스 발표 및 논문 작성'
    ],
    requirements: [
      'Security Research 경력 7년 이상',
      'Windows Kernel 깊은 이해 (필수)',
      'WinDbg, IDA Pro 숙련',
      'C/C++ 고급 프로그래밍 능력',
      'CVE 발표 또는 취약점 연구 실적',
      '영어 커뮤니케이션 능력 (필수)'
    ],
    preferred: [
      'Pwn2Own, Tianfu Cup 입상 경력',
      'Windows Exploit 개발 경험',
      'Hypervisor (Hyper-V) 보안 연구',
      'Fuzzing (WinAFL) 경험',
      'Black Hat, BlueHat 발표 경험',
      'MSRC Top Contributor 경력'
    ],
    benefits: [
      '연봉 $170K–$230K + RSU',
      '레드몬드 또는 서울 오피스',
      '재택근무 주 2회',
      '최신 연구 장비 제공',
      '글로벌 보안 컨퍼런스 참가 지원',
      'Microsoft 제품 할인'
    ]
  },
  {
    id: 'job19',
    user_id: 'recruiter19',
    type: 'job' as const,
    title: '[KAIST 사이버보안연구센터] AI 보안 연구원 (박사급)',
    content: 'KAIST에서 AI/ML 보안 연구원을 채용합니다. 적대적 머신러닝(Adversarial ML), LLM 탈옥 공격 연구, AI 모델 워터마킹. 박사 학위 소지자 또는 박사 과정 수료자. 연봉 5,500만~8,000만 원 + 연구비.',
    company: 'KAIST',
    position: 'AI 보안 연구원',
    salary: '5,500만~8,000만원',
    location: '대전',
    experience: '박사 학위',
    deadline: new Date(Date.now() + 60 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['research', 'ai-security', 'adversarial-ml', 'llm'],
    category: 'research',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 389,
    replies_count: 89,
    views_count: 7450,
    created_at: new Date(Date.now() - 40 * 3600000).toISOString(),
    profiles: { id: 'recruiter19', username: 'kaist_security', display_name: 'KAIST Security Lab', points: 5230, reputation: 1046 },
    apply_url: 'https://www.kaist.ac.kr/',
    responsibilities: [
      'Adversarial ML 공격 및 방어 기법 연구',
      'LLM 탈옥 공격 (Jailbreak) 연구',
      'AI 모델 워터마킹 및 저작권 보호',
      'Backdoor Attack, Data Poisoning 연구',
      '국제 학술지 논문 발표 (Top-tier)',
      '대학원생 지도 및 연구 협업'
    ],
    requirements: [
      'AI/ML 보안 관련 박사 학위 (필수)',
      'Top-tier 학회 (S&P, USENIX, CCS) 논문 실적',
      'Python, PyTorch/TensorFlow 능숙',
      'Adversarial ML 연구 경험',
      '영어 논문 작성 능력',
      '연구 열정 및 독립적 연구 수행 능력'
    ],
    preferred: [
      'LLM 보안 (GPT, Claude) 연구 경험',
      'AI Red Team 경험',
      'Federated Learning 보안 연구',
      'AI 모델 설명 가능성 (XAI) 연구',
      '국제 학회 발표 경험',
      '산학 협력 프로젝트 경험'
    ],
    benefits: [
      '연봉 5,500만~8,000만원 + 연구비',
      '연구 자율성 보장',
      '최신 GPU 서버 (A100, H100) 제공',
      '국제 학회 참가비 전액 지원',
      'KAIST 교원 임용 우대',
      '대전 캠퍼스 근무'
    ]
  },
  {
    id: 'job20',
    user_id: 'recruiter20',
    type: 'job' as const,
    title: '[ETRI] 양자내성암호(PQC) 연구원 채용 (신입 가능)',
    content: 'ETRI 암호·인증연구실에서 PQC 연구원을 채용합니다. NIST PQC 표준(CRYSTALS-Kyber·Dilithium) 구현 최적화, 하드웨어 가속, 프로토콜 통합. 암호학 석사 이상. 연봉 5,000만~7,500만 원.',
    company: 'ETRI',
    position: '양자내성암호 연구원',
    salary: '5,000만~7,500만원',
    location: '대전',
    experience: '석사 이상',
    deadline: new Date(Date.now() + 52 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['research', 'cryptography', 'post-quantum', 'pqc'],
    category: 'research',
    region: 'domestic',
    level: 'junior',
    status: 'open',
    likes_count: 312,
    replies_count: 71,
    views_count: 5890,
    created_at: new Date(Date.now() - 48 * 3600000).toISOString(),
    profiles: { id: 'recruiter20', username: 'etri_security', display_name: 'ETRI Security', points: 4780, reputation: 956 },
    apply_url: 'https://www.etri.re.kr/',
    responsibilities: [
      'NIST PQC 표준 (Kyber, Dilithium) 구현',
      'PQC 알고리즘 최적화 (ARM, x86)',
      '하드웨어 가속 (FPGA, ASIC) 연구',
      'TLS, IPsec 등 프로토콜 PQC 통합',
      'PQC 표준화 활동 참여',
      '연구 보고서 및 논문 작성'
    ],
    requirements: [
      '암호학 석사 학위 이상',
      'C/C++ 프로그래밍 능력',
      'PQC 알고리즘 (Lattice, Code-based) 이해',
      '수학적 배경 (정수론, 대수학)',
      '영어 논문 독해 능력',
      '연구 열정 및 학습 의지'
    ],
    preferred: [
      'PQC 구현 (liboqs, PQClean) 경험',
      'Side-channel 공격 분석 경험',
      'FPGA 개발 (Verilog, VHDL) 경험',
      '암호학 국제 학회 (CRYPTO, Asiacrypt) 논문',
      'CTF Crypto 분야 경험',
      '오픈소스 암호 라이브러리 기여'
    ],
    benefits: [
      '연봉 5,000만~7,500만원 (호봉제)',
      '공공연구기관 안정적 근무',
      '워라밸 보장',
      '최신 연구 장비 제공',
      '국내외 학회 참가 지원',
      '대전 본원 근무'
    ]
  },

  // ─── Bug Bounty / Vulnerability Disclosure ───
  {
    id: 'job21',
    user_id: 'recruiter21',
    type: 'job' as const,
    title: '[HackerOne] Staff Security Analyst – Triage & Research',
    content: 'HackerOne에서 버그바운티 트리아지 전문가를 채용합니다. 제출된 취약점 검증·분류, 연구자 커뮤니티 지원, 취약점 트렌드 분석 보고서 작성. OWASP·CVE 분류 경험 필수. 연봉 $100K–$140K. 완전 원격.',
    company: 'HackerOne',
    position: 'Staff Security Analyst',
    salary: '$100K–$140K',
    location: 'Remote',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 33 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['bug-bounty', 'vulnerability', 'triage', 'remote'],
    category: 'bugbounty',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 445,
    replies_count: 102,
    views_count: 8670,
    created_at: new Date(Date.now() - 9 * 3600000).toISOString(),
    profiles: { id: 'recruiter21', username: 'hackerone_careers', display_name: 'HackerOne', points: 5890, reputation: 1178 },
    apply_url: 'https://www.hackerone.com/careers',
    responsibilities: [
      '버그바운티 제출 취약점 검증 및 트리아지',
      'CVSS 점수 산정 및 심각도 분류',
      '연구자 커뮤니티 지원 및 피드백',
      '취약점 트렌드 분석 보고서 작성',
      '고객사 대상 취약점 브리핑',
      'Bug Bounty 프로그램 운영 지원'
    ],
    requirements: [
      'Vulnerability Analysis 경력 5년 이상',
      'OWASP Top 10, SANS Top 25 전문 지식',
      'CVSS 점수 산정 경험',
      'Bug Bounty 플랫폼 사용 경험',
      '영어 커뮤니케이션 능력 (필수)',
      '연구자 커뮤니티 이해'
    ],
    preferred: [
      'Bug Bounty 프로그램 참여 경험',
      'CVE Numbering Authority (CNA) 경험',
      'Web/Mobile/API 취약점 분석 경험',
      'CISSP, CEH 자격증',
      '보안 컨퍼런스 발표 경험',
      '다국어 능력 (한국어, 일본어 등)'
    ],
    benefits: [
      '연봉 $100K–$140K',
      '100% 원격 근무',
      '유연한 근무 시간',
      '최신 분석 장비 제공',
      '연간 교육비 $5,000 지원',
      '무제한 유급휴가'
    ]
  },
  {
    id: 'job22',
    user_id: 'recruiter22',
    type: 'job' as const,
    title: '[삼성전자] MPS(Mobile Product Security) 취약점 연구원',
    content: '삼성전자 MPS팀에서 Galaxy 기기 보안 연구원을 채용합니다. Android 커스텀 커널 취약점 분석, TrustZone·Knox 보안 검증, 삼성 버그바운티 프로그램 운영. 모바일 보안 경력 3년 이상. 연봉 7,500만~1억 2,000만 원.',
    company: '삼성전자',
    position: 'MPS 취약점 연구원',
    salary: '7,500만~1억 2,000만원',
    location: '수원',
    experience: '3년 이상',
    deadline: new Date(Date.now() + 26 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['mobile-security', 'android', 'trustzone', 'bug-bounty'],
    category: 'bugbounty',
    region: 'domestic',
    level: 'senior',
    status: 'open',
    likes_count: 523,
    replies_count: 119,
    views_count: 10120,
    created_at: new Date(Date.now() - 30 * 3600000).toISOString(),
    profiles: { id: 'recruiter22', username: 'samsung_mps', display_name: 'Samsung MPS', points: 6120, reputation: 1224 },
    apply_url: 'https://security.samsungmobile.com/',
    responsibilities: [
      'Galaxy 기기 Android 커널 취약점 분석',
      'TrustZone, Knox 보안 검증',
      '삼성 버그바운티 프로그램 운영',
      '제출된 취약점 트리아지 및 패치 협업',
      'Mobile Security 가이드라인 수립',
      '보안 연구 및 CVE 발표'
    ],
    requirements: [
      'Mobile Security 경력 3년 이상',
      'Android 커널 및 프레임워크 이해',
      'ARM 아키텍처 및 TrustZone 지식',
      'IDA Pro, Ghidra 리버싱 도구 숙련',
      'C/C++, Java/Kotlin 개발 능력',
      'Bug Bounty 프로그램 이해'
    ],
    preferred: [
      'CVE 발표 실적 (Android, TrustZone)',
      'Google VRP, Samsung MPS 참여 경험',
      'Fuzzing (AFL, Syzkaller) 경험',
      'Knox, SELinux 정책 분석 경험',
      'Pwn2Own Mobile 참여 경험',
      '보안 컨퍼런스 발표 경험'
    ],
    benefits: [
      '연봉 7,500만~1억 2,000만원',
      '자율 출퇴근제',
      '재택근무 주 1회',
      '최신 Galaxy 기기 제공',
      '교육비 전액 지원',
      '수원 사업장 근무 (셔틀버스 운행)'
    ]
  },

  // ─── Security Consulting / GRC ───
  {
    id: 'job23',
    user_id: 'recruiter23',
    type: 'job' as const,
    title: '[딜로이트] 사이버보안 컨설턴트 – AI·데이터 보안 (신입 가능)',
    content: '딜로이트 사이버 리스크 팀에서 AI·데이터 보안 컨설턴트를 채용합니다. AI 거버넌스 프레임워크 수립, 개인정보보호(GDPR·PIPA) 컨설팅, 데이터 보안 아키텍처 설계. CISM·CISSP 우대. 연봉 6,000만~1억 원.',
    company: '딜로이트',
    position: '사이버보안 컨설턴트',
    salary: '6,000만~1억원',
    location: '서울',
    experience: '신입~3년',
    deadline: new Date(Date.now() + 44 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['consulting', 'ai-governance', 'privacy', 'big4'],
    category: 'consulting',
    region: 'domestic',
    level: 'junior',
    status: 'open',
    likes_count: 412,
    replies_count: 95,
    views_count: 7890,
    created_at: new Date(Date.now() - 44 * 3600000).toISOString(),
    profiles: { id: 'recruiter23', username: 'deloitte_cyber', display_name: 'Deloitte Cyber', points: 5340, reputation: 1068 },
    apply_url: 'https://www2.deloitte.com/kr/ko/careers.html',
    responsibilities: [
      'AI 거버넌스 프레임워크 수립 컨설팅',
      '개인정보보호 (GDPR, PIPA) 컴플라이언스 지원',
      '데이터 보안 아키텍처 설계',
      'AI 리스크 평가 및 대응 방안 수립',
      '고객사 보안 정책 및 가이드라인 작성',
      '보안 진단 및 개선 과제 도출'
    ],
    requirements: [
      '정보보안 관련 학과 졸업 또는 동등 경력',
      'AI/ML 기본 지식',
      '개인정보보호법 (PIPA, GDPR) 이해',
      'MS Office (PPT, Excel) 능숙',
      '논리적 사고 및 문서 작성 능력',
      '고객 커뮤니케이션 능력'
    ],
    preferred: [
      'CISM, CISSP, CISA 자격증',
      'AI 거버넌스 또는 데이터 보안 프로젝트 경험',
      'ISO27001, ISO27701 인증 경험',
      '컨설팅 펌 또는 Big4 근무 경험',
      '영어 커뮤니케이션 능력',
      '보안 컨퍼런스 참가 경험'
    ],
    benefits: [
      '연봉 6,000만~1억원 (경력에 따라)',
      '자율 출퇴근제',
      '재택근무 주 2회',
      '최신 노트북 제공',
      '자격증 취득 전액 지원',
      '서울 강남 오피스 근무'
    ]
  },
  {
    id: 'job24',
    user_id: 'recruiter24',
    type: 'job' as const,
    title: '[금융보안원] 금융 사이버보안 전문가 채용 (신입)',
    content: '금융보안원에서 금융권 사이버보안 전문가를 채용합니다. 금융 ISAC 운영, 이상 거래 탐지 시스템(FDS) 고도화, 금융권 보안 가이드라인 수립. 금융권 경험 우대, 정보보안기사 필수. 연봉 5,500만~8,000만 원.',
    company: '금융보안원',
    position: '금융 사이버보안 전문가',
    salary: '5,500만~8,000만원',
    location: '서울',
    experience: '신입~2년',
    deadline: new Date(Date.now() + 58 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['financial-security', 'fds', 'isac', 'public-sector'],
    category: 'consulting',
    region: 'domestic',
    level: 'junior',
    status: 'open',
    likes_count: 356,
    replies_count: 82,
    views_count: 6780,
    created_at: new Date(Date.now() - 52 * 3600000).toISOString(),
    profiles: { id: 'recruiter24', username: 'fsec_careers', display_name: 'Financial Security Institute', points: 4890, reputation: 978 },
    apply_url: 'https://www.fsec.or.kr/',
    responsibilities: [
      '금융 ISAC (정보공유분석센터) 운영',
      '이상 거래 탐지 시스템 (FDS) 고도화',
      '금융권 사이버 위협 모니터링',
      '금융권 보안 가이드라인 수립',
      '금융기관 보안 점검 및 컨설팅',
      '금융 보안 교육 및 훈련'
    ],
    requirements: [
      '정보보안기사 자격증 (필수)',
      '정보보안 관련 학과 졸업 또는 동등 경력',
      '금융권 보안 이해',
      'Python, SQL 기본 능력',
      '문서 작성 및 커뮤니케이션 능력',
      '공공기관 근무 의지'
    ],
    preferred: [
      'CISSP, CISA 자격증',
      '금융권 (은행, 증권, 카드) 근무 경험',
      'FDS, AML 시스템 경험',
      'SIEM, EDR 운영 경험',
      '금융보안 컴플라이언스 (전자금융감독규정) 이해',
      '보안 동아리 또는 연구실 활동'
    ],
    benefits: [
      '연봉 5,500만~8,000만원 (호봉제)',
      '공공기관 안정적 근무',
      '워라밸 보장 (정시 퇴근)',
      '교육비 전액 지원',
      '서울 오피스 근무',
      '금융권 보안 전문가 경력 인정'
    ]
  },
  {
    id: 'job25',
    user_id: 'recruiter25',
    type: 'job' as const,
    title: '[Palo Alto Networks] UNIT 42 Threat Intelligence Analyst (Seoul)',
    content: 'Palo Alto Networks UNIT 42에서 위협 인텔리전스 분석가를 채용합니다. 국가 지원 해킹 그룹 추적, 랜섬웨어 생태계 분석, 고객 대상 위협 브리핑. MITRE ATT&CK 전문가 수준 필수. 연봉 $120K–$165K + RSU.',
    company: 'Palo Alto Networks',
    position: 'Threat Intelligence Analyst',
    salary: '$120K–$165K',
    location: '서울',
    experience: '5년 이상',
    deadline: new Date(Date.now() + 36 * 24 * 3600000).toISOString(),
    bookmarked: false,
    tags: ['threat-intelligence', 'apt-tracking', 'ransomware', 'unit42'],
    category: 'soc',
    region: 'overseas',
    level: 'senior',
    status: 'open',
    likes_count: 589,
    replies_count: 136,
    views_count: 11230,
    created_at: new Date(Date.now() - 7 * 3600000).toISOString(),
    profiles: { id: 'recruiter25', username: 'unit42_careers', display_name: 'Palo Alto UNIT 42', points: 6780, reputation: 1356 },
    apply_url: 'https://www.paloaltonetworks.com/company/careers/unit-42',
    responsibilities: [
      '국가 지원 해킹 그룹 (APT) 추적 및 분석',
      '랜섬웨어 생태계 및 TTP 분석',
      '위협 인텔리전스 보고서 작성',
      '고객사 대상 위협 브리핑',
      'MITRE ATT&CK 기반 TTP 매핑',
      '글로벌 위협 트렌드 분석'
    ],
    requirements: [
      'Threat Intelligence 경력 5년 이상',
      'MITRE ATT&CK 프레임워크 전문가 수준',
      'APT 그룹 (Lazarus, APT29 등) 분석 경험',
      '악성코드 분석 및 IOC 추출',
      '영어 보고서 작성 능력 (필수)',
      '고객 커뮤니케이션 능력'
    ],
    preferred: [
      'GCTI, GIAC 자격증',
      'Threat Intelligence 플랫폼 (MISP, ThreatConnect) 경험',
      'YARA 룰 작성 경험',
      'Ransomware 협상 또는 대응 경험',
      '보안 컨퍼런스 발표 경험',
      '다국어 능력 (한국어, 중국어 등)'
    ],
    benefits: [
      '연봉 $120K–$165K + RSU',
      '서울 오피스 근무',
      '재택근무 주 2회',
      '최신 분석 장비 제공',
      'SANS 교육 전액 지원',
      '글로벌 보안 컨퍼런스 참가 지원'
    ]
  }
];